module.exports = __webpack_public_path__ + "img/angel-2.107bedfe.jpg";